import styled, { css } from 'styled-components';
export var IconBlock = styled.span.withConfig({
  displayName: "partials__IconBlock",
  componentId: "sc-1t2wabu-0"
})(["display:flex;position:absolute;top:11px;right:6px;color:", ";transition:color 0.2s ease-in;svg{margin-left:4px;}"], function (_ref) {
  var theme = _ref.theme,
    isOpen = _ref.isOpen;
  return isOpen ? theme.colors.primary : theme.colors.ui;
});
var borderStyles = css(["border:1px solid ", ";border-radius:", ";box-shadow:inset 0 0 2px ", ";transition:all 0.3s ease-in-out;"], function (_ref2) {
  var theme = _ref2.theme,
    isFocused = _ref2.isFocused;
  return isFocused ? theme.colors.primaryM : theme.colors.terciaryM;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius;
}, function (_ref4) {
  var theme = _ref4.theme,
    isFocused = _ref4.isFocused;
  return isFocused ? theme.colors.primaryM : theme.colors.terciaryM;
});
export var InputContainer = styled.div.withConfig({
  displayName: "partials__InputContainer",
  componentId: "sc-1t2wabu-1"
})(["display:flex;position:relative;border:1px solid ", ";margin-bottom:16px;", " input{display:block;width:100%;padding:9px 6px;border-radius:4px;font-size:14px;line-height:26px;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.ui;
}, borderStyles);
export var ActionBlock = styled.div.withConfig({
  displayName: "partials__ActionBlock",
  componentId: "sc-1t2wabu-2"
})(["display:flex;align-items:center;flex-shrink:0;padding:9px 6px;"]);